<template>
  <div id="func-14">
    <FuncionalidadeHeader
      :titulo="tituloNavegacao"
    />
    <div class="func-historico">
      <div class="filters-header">
        <filtros
          v-for="(filtro,index) in filtros"
          :key="index"
          :classe=" outputJson[filtro.field] ? 'btn-filter-ativo' : 'btn-filter'"
          :name="filtro.name"
          @clickButton="showDialog = true"
        />
        <el-button
          v-if="Object.keys(outputJson).length > 0"
          type="text"
          @click="limparFiltros"
        >
          Limpar
        </el-button>

        <filterDialog
          :componentList="inputJson"
          :open.sync="showDialog"
          :title="title"
          :output.sync="outputJson"
        />
      </div>
      <div v-if="debitosFiltrados.length === 0"
           style="padding: 30px 18px; height: 100px;"
           slot="append">
        <div class="text-center">
          <div style="margin-bottom: 20px">
            <inline-svg fill="#006FB9" height="120" style="" :src="require('@/assets/icons/img_helper_empty_default.svg')"/>
          </div>
          <span class="tituloVazio">
            {{ this.funcionalidade.parametros.textos.tituloVazio }}
          </span><br/>
          <span class="textoVazio">
            {{ this.funcionalidade.parametros.textos.textoVazio }}
          </span>
        </div>
      </div>
      <listagemStatus
        v-else
        :click-row="onClickRow"
        :columns="columns"
        :listagemData="debitosFiltrados"
        :status-field="'situacao'"
        :no-hover="noHover"
        empty-message="Sem dados"
      />
    </div>
  </div>
</template>
<script>
import ListagemStatus from '@/components/listagemColumn/ListagemStatus.vue'
import Filtros from '@/components/buttons/Filtros.vue'
import MultLineItem from '@/components/listagemColumn/MultLineItem.vue'
import StatusItem from '@/components/listagemColumn/StatusItem.vue'
import DataItem from '@/components/listagemColumn/DataItem.vue'
import MoedaItem from '@/components/listagemColumn/MoedaItem.vue'
import FilterDialog from '@/components/filterDialog/FilterDialog'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import AcoesDebito from '@/views/14/AcoesDebito'
import ArrowButton from '@/components/listagemColumn/ArrowButton'
import { EnumCanalAtendimentoOrigem } from '@/constants/EnumCanalAtendimentoOrigem'
import { mapGetters, mapState } from 'vuex'
import inlineSvg from 'vue-inline-svg'

export default {
  name: 'Func14Historico',
  components: {
    inlineSvg,
    FuncionalidadeHeader,
    ListagemStatus,
    Filtros,
    FilterDialog
  },
  data () {
    return {
      filtros: [
        {
          name: 'Ordenar',
          field: 'ordenacao'
        }
      ],
      contratosDebitos: [],
      title: 'Filtros',
      // language=JSON
      inputText: `[
        {
          "title": "",
          "field": "ordenacao",
          "field": "ordenacao",
          "type": "radio",
          "default": {},
          "elements": [
            {
              "name": "Próximos vencimentos primeiro",
              "field": "dataVencimento",
              "order": "DESC",
              "id": 1
            },
            {
              "name": "Maior valor primeiro",
              "field":  "valor",
              "order":  "DESC",
              "id": 2
            },
            {
              "name": "Assunto",
              "field":  "descricao",
              "order":  "ASC",
              "id": 3
            },
            {
              "name": "Situação",
              "field":  "situacao.id",
              "order":  "ASC",
              "id": 4
            }
          ]
        }
      ]
      `,
      outputJson: {},
      showDialog: false
    }
  },
  computed: {
    ...mapGetters('Login', ['user', 'contratos']),
    ...mapState('SetupApp', ['funcionalidade', 'apiFuncionalidade']),
    ...mapGetters('SetupApp', ['estilo', 'canalAtendimentoOrigem', 'textoVinculoContrato']),
    columns () {
      return [
        { field: 'descricao', negrito: true, header: { label: 'Título', sortable: true } },
        {
          field: 'descricaoContrato',
          component: MultLineItem,
          lines: ['plano', 'numeroContrato'],
          header: { label: 'Plano - ' + this.textoVinculoContrato, sortable: true },
          click: this.onClickRow
        },
        { field: 'situacao', component: StatusItem, header: { label: 'Situação', sortable: true } },
        [
          { field: 'dataVencimento', component: DataItem, title: 'Vencimento', showColumn: this.showColumnVencimento },
          { field: 'dataVencimentoAtualizado', component: DataItem, title: 'Vencimento Atualizado', showColumn: this.showColumnVencimentoAtualizado }
        ],
        [
          { field: 'valor', component: MoedaItem, cifra: 'R$', decimals: 2, title: 'Valor', showColumn: this.showColumnValor },
          { field: 'valorAtualizado', component: MoedaItem, cifra: 'R$', decimals: 2, title: 'Valor Atualizado', showColumn: this.showColumnValorAtualizado }
        ],
        this.defineColunaAcao
      ]
    },
    numeroContrato () {
      return this.$route.query.numeroContrato
    },
    debitos () {
      if (this.numeroContrato) {
        const contrato = this.contratosMap.find((contrato) => contrato.numeroContrato === this.numeroContrato)

        return contrato.data.map((debito) => {
          return {
            ...debito,
            plano: contrato.plano,
            numeroContrato: contrato.numeroContrato
          }
        })
      }

      let listaContratosDebitos = []

      this.contratosMap.forEach((contrato) => {
        listaContratosDebitos = listaContratosDebitos.concat(contrato.data.map((debito) => {
          return {
            ...debito,
            plano: contrato.plano,
            numeroContrato: contrato.numeroContrato
          }
        }))
      })

      return listaContratosDebitos
    },
    debitosFiltrados () {
      if (!this.outputJson) {
        return this.debitos
      }

      let lista = [...this.debitos]
      if (this.outputJson.ordenacao) {
        const field = this.outputJson.ordenacao.field
        lista = lista.sort((a, b) => {
          const fields = field.split('.')
          let valorA = a
          for (let j = 0; j < fields.length; j++) {
            valorA = valorA[fields[j]]
          }
          let valorB = b
          for (let j = 0; j < fields.length; j++) {
            valorB = valorB[fields[j]]
          }

          if (this.outputJson.ordenacao.order === 'ASC') {
            return valorA > valorB ? 1 : valorA < valorB ? -1 : 0
          } else {
            return valorA > valorB ? -1 : valorA < valorB ? 1 : 0
          }
        })
      }

      return lista
    },
    contratosMap () {
      return this.contratos.map((contrato) => {
        let dadosLista = this.contratosDebitos.find(
          (debito) => contrato.numeroContrato === debito.numeroContrato
        ) || {}
        return {
          plano: contrato.descricaoContrato,
          numeroContrato: contrato.numeroContrato,
          data: dadosLista.debitos || []
        }
      })
    },
    inputJson () {
      try {
        return JSON.parse(this.inputText)
      } catch (ignored) {
        return {}
      }
    },
    tituloNavegacao () {
      return this.funcionalidade.parametros.dashboard.nome
    },
    defineColunaAcao () {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return { field: '', component: AcoesDebito }
        default:
          return { field: '', component: ArrowButton, acao: this.clickDetalhe }
      }
    },
    noHover () {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return true
        default:
          return false
      }
    },
    exibeVencimento () {
      return this.funcionalidade.parametros.exibicaoVencimento || 1
    },
    exibeValor () {
      return this.funcionalidade.parametros.exibicaoValor || 1
    },
    showColumnVencimento () {
      return [1, 3].includes(this.exibeVencimento)
    },
    showColumnValor () {
      return [1, 3].includes(this.exibeValor)
    },
    showColumnVencimentoAtualizado () {
      return [2, 3].includes(this.exibeVencimento)
    },
    showColumnValorAtualizado () {
      return [2, 3].includes(this.exibeValor)
    }
  },
  methods: {
    async init () {
      await this.listaDetalhe()
    },
    onClickRow (row) {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return false
        default:
          return this.$router.push({
            path: '/14/detalhe',
            query: {
              idTitulo: row['idTitulo'],
              codigoTitulo: row['codigoTitulo'],
              nome: row['descricao']
            }
          })
      }
    },
    async listaDetalhe () {
      const response = await this.apiFuncionalidade.lista({
        loading: true,
        handlerErrorIgnore: [404]
      })

      this.contratosDebitos = response.data.contratos
    },
    clickDetalhe (row) {
      return this.$router.push({
        path: '/14/detalhe',
        query: {
          idTitulo: row['idTitulo'],
          codigoTitulo: row['codigoTitulo'],
          nome: row['descricao']
        }
      })
    },
    limparFiltros () {
      this.outputJson = {}
    },
    clickDownload (row) {
      alert(`Inicia Download do Boleto de id: ${row['idTitulo']}`)
    },
    clickComprovante (row) {
      alert(`Incia Download do Comprovante de id: ${row['idTitulo']}`)
    }
  },
  mounted () {
    this.init()
  }
}
</script>
